import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { AsaxHeaderService, AsaxResultTableService, ColumnFilter, HeaderFilter, AsaxScrollingService } from 'asax-common';
import { Observable, fromEvent, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'asax-header-filters-container',
  templateUrl: './header-filters-container.component.html',
  styleUrls: ['./header-filters-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderFiltersContainerComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'navbar-collapse';

  @ViewChild('filtersContainer', { read: ElementRef }) public filtersContainer: ElementRef<any>;

  headerFilters: Observable<HeaderFilter[]>;
  validColumnsFiltersForActiveTab: ColumnFilter[];

  displayClearAllHeaderFilters: boolean;
  canScrollLeft: Observable<boolean>;
  canScrollRight: Observable<boolean>;

  private resizeSubscription: Subscription;

  constructor(private readonly asaxHeaderService: AsaxHeaderService,
              private readonly asaxResultTableService: AsaxResultTableService,
              private readonly ref: ChangeDetectorRef,
              public readonly scrollingService: AsaxScrollingService) {
                
    this.headerFilters = this.asaxHeaderService.getHeaderFilters();

    this.asaxHeaderService.getHeaderFilters().pipe(
      map(filters => filters?.filter(filter => filter?.valueToDisplay?.length > 0)),
      tap(filters => this.displayClearAllHeaderFilters = filters?.length > 0),
      tap(() => this.scrollingService.delayedCheckScroll(this.filtersContainer, 'HeaderFiltersContainerComponent')),
      tap(() => this.ref.markForCheck())
    ).subscribe();

    this.asaxResultTableService.getColumnsFiltersForActiveTabSubject().pipe(
      tap(columnFilters => this.validColumnsFiltersForActiveTab = columnFilters?.filter(columnFilter => columnFilter?.value?.length > 0)
        .filter(columnFilter => !columnFilter?.isInvalid)
        .filter(columnFilter => !columnFilter?.isDisabled)
      ),
      tap(() => this.ref.markForCheck())
    ).subscribe();

    this.canScrollLeft = this.scrollingService.getHeaderCanScrollLeft();
    this.canScrollRight = this.scrollingService.getHeaderCanScrollRight();
  }

  ngAfterViewInit(): void {
    // Detect window resize
    this.resizeSubscription = fromEvent(window, 'resize').pipe(
      tap(() => this.scrollingService.delayedCheckScroll(this.filtersContainer, 'HeaderFiltersContainerComponent')),
      tap(() => this.ref.markForCheck())
    ).subscribe();
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  onHeaderFilter(headerFilter: HeaderFilter): void {
    this.asaxHeaderService.upsertHeaderFilter(headerFilter);
  }

  onRemoveHeaderFilter(headerFilterId: string): void {
    this.asaxHeaderService.removeHeaderFilter(headerFilterId);
  }

  removeHeaderFilters(): void {
    this.asaxHeaderService.removeHeaderFilters();
  }

  public scrollRight(): void {
    this.scrollingService.scrollRight(this.filtersContainer, 'HeaderFiltersContainerComponent');
  }

  public scrollLeft(): void {
    this.scrollingService.scrollLeft(this.filtersContainer, 'HeaderFiltersContainerComponent');
  }
}
